import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';

/* Layouts */
import PublicLayout from './components/layout/PublicLayout';
import AdminLayout from './pages/admin/AdminLayout';
import ProtectedRoute from './components/common/ProtectedRoute';

/* Public Pages */
import HomePage from './pages/public/HomePage';
import EventsPage from './pages/public/EventsPage';
import TrainersPage from './pages/public/TrainersPage';
import GymsPage from './pages/public/GymsPage';
import FAQPage from './pages/public/FAQPage';
import AboutPage from './pages/public/AboutPage';
import ContactPage from './pages/public/ContactPage';

/* Auth Pages */
import LoginPage from './pages/auth/LoginPage';

/* Admin Pages */
import DashboardPage from './pages/admin/DashboardPage';
import SportTypesAdmin from './pages/admin/SportTypesAdmin';
import EventsAdmin from './pages/admin/EventsAdmin';
import TrainersAdmin from './pages/admin/TrainersAdmin';
import BranchesAdmin from './pages/admin/BranchesAdmin';
import TrainingSchoolsAdmin from './pages/admin/TrainingSchoolsAdmin';
import AchievementsAdmin from './pages/admin/AchievementsAdmin';
import FAQsAdmin from './pages/admin/FAQsAdmin';
import AboutUsAdmin from './pages/admin/AboutUsAdmin';
import RequestsAdmin from './pages/admin/RequestsAdmin';
import CommentsAdmin from './pages/admin/CommentsAdmin';
import GroupsAdmin from './pages/admin/GroupsAdmin';
import StudentsAdmin from './pages/admin/StudentsAdmin';
import EnrolmentsAdmin from './pages/admin/EnrolmentsAdmin';
import LessonsAdmin from './pages/admin/LessonsAdmin';
import AttendancesAdmin from './pages/admin/AttendancesAdmin';
import TransactionsAdmin from './pages/admin/TransactionsAdmin';

const App = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/trainers" element={<TrainersPage />} />
            <Route path="/gyms" element={<GymsPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/login" element={<LoginPage />} />
          </Route>

          {/* Admin Routes (Protected) */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="sport-types" element={<SportTypesAdmin />} />
            <Route path="events" element={<EventsAdmin />} />
            <Route path="trainers" element={<TrainersAdmin />} />
            <Route path="branches" element={<BranchesAdmin />} />
            <Route path="training-schools" element={<TrainingSchoolsAdmin />} />
            <Route path="achievements" element={<AchievementsAdmin />} />
            <Route path="faqs" element={<FAQsAdmin />} />
            <Route path="about-us" element={<AboutUsAdmin />} />
            <Route path="requests" element={<RequestsAdmin />} />
            <Route path="comments" element={<CommentsAdmin />} />
            <Route path="groups" element={<GroupsAdmin />} />
            <Route path="students" element={<StudentsAdmin />} />
            <Route path="enrolments" element={<EnrolmentsAdmin />} />
            <Route path="lessons" element={<LessonsAdmin />} />
            <Route path="attendances" element={<AttendancesAdmin />} />
            <Route path="transactions" element={<TransactionsAdmin />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
};

export default App;
